export default "__VITE_ASSET__C2gCN60H__$_?react__"